/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:31:10
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ኽፈት",
    name2: "ቦታ ኣትሕዝ",
    name3: "ብ Carlcare፣ ትእዛዝካ ኣብ ዝኾነ እን ምርግጋፅ ትኽእል ኢኻ",
    name4: "",
    name5: "ናብ የማን ኣንሸራትት",
    name6: "ምርግጋፅ ተዛዚሙ",
  },
  order: {
    name1: "ናይ መሳርሒ ሞዴል ምረፅ",
    name2: "ዝተሰሓሓተ ገለፃ",
    name3: "ናይ ግልጋሎት መኽዘን ንምምራፅ ንኻእ",
    name4: "ናይ ግልጋሎት መኽዘን፡",
    name5: "ቦታ ዝተትሓዘሉ ግዜ፡",
    name6: "በይዞም ናይ መሳርሒኦም ፀገም ብዝርዝ ይመዝግቡ!",
    name7: "ናይ ዝበፅሐሉ ግዜ ንምምራፅ ንኻእ",
    name8: "በይዘኦም ትኽክለኛ ኣድራሽኦም የእትዉ ስለዝኾነ ክንረኽቦም ንኽእል ኢና",
    name9: "ዝርከቡ ቦታ ናይ ምትሓዝ እዋን ዝስዕቡ እዮም",
    name10: "በይዘኦም ስልኪ ቑፅሮም የእትዉ",
    name11: "ዋጋ",
    name12: "ናይ ዉልቀ ሓበሬታ፡",
    name13: "በይዘኦም ሽሞም የእትዉ",
    name14: "ኣእትዉ",
    name15: "ሰርዝ",
    name16: "ሕራይ",
  },
  shops: {
    name1: "ብዝመረፅካዮ ብራንድ ብምምስራት፣ እቶም ዝስዕቡ መደብራት ከገልግሉኻ እዮም!",
    name2: "ተወሰኽቲ ናይ ሸቐጥ መኽዘናት ኣብ ቐረባ እዋን! ምሳና ይፅንሑ!",
  },
  price: {
    name1: "ብራንድ",
    name2: "ሞዴል",
    name3: "ነገር",
    name4: "ዋጋ",
    name5: "ምሕዝነታዊ መዘኻኸሪ፡",
    name6: "እቶም ዋጋ ንመጣቐሲ እዮም፣ ስለዝኾነ እቲ ትኽክለኛ ዋጋ በቲ ናይ መሳርሒኻ ብልሽት ኹነት ይዉነን",
    name7: "ፍሉይ ምልክት ተዘይሃልዩዎ፣ እቲ ናይ ዋጋ ክፍሊ ናይ ከባቢ ሸርፊ ክፍሊ እዩ",
    name8: "ይቕረታ! ኣብቲ ናይ ሕጂ ክልል ምንም ናይ  ዋጋ ሓበሬታ የለን",
    name11:"ወፃኢታት ጉልበት",
    name12:"ጠቕላላ ዋጋ",
    name13: "5. ወፃኢ ጉልበት \"/\" እንተኾይኑ፣ ወፃኢ ጉልበት ምስቲ ድንኳን ምምኽኻር የድሊ ማለት እዩ፡፡",
    item_main_board: "ዋና ቦርድ",
    item_screen_frame: "ስክሪን (ፍሬም)",
    item_screen_screen_frame: "ካልኣዊ ስክሪን (ፍሬም)",
    item_touch_screen: "ታች ስክሪን",
    item_camera: "ካሜራ",
    item_fixed_focus_camera: "ቀዋሚ ትኹረት ካሜራ",
    item_auto_focus_camera: "አውቶማቲክ ትኹረት ካሜራ",
    item_screen: "ስክሪን",
    item_secondary_screen: "ካልኣይ ስክሪን",
    item_fingerprint_module: "ናይ ኣፃብዕቲ ዓሸራ ሞዱል",
    item_speaker: "መጋዉሒ ድምፂ",
    item_receiver: "ተቐባሊ",
    item_small_board: "ንእሽቶይ ቦርድ",
    item_battery_cover: "ሽፋን ባትሪ",
    item_battery: "ባትሪ",
    item_charger: "ቻርጀር",
    item_usb_cable: "ናይ USB ገመድ",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ዳታ የለን",
    name2: "ግልጋሎት መቕረቢ፡",
    name3: "ናይ ግልጋሎት ብራንድ፡",
    name4: "ቴሌፎን፡",
    name5: "ናይ ትእዛዝ በዝሒ፡",
    name6: "ናይ ግልጋሎት ምድብ",
    name7: "ናይ ግልጋሎት ከባቢ፡",
    name8: "ናይ ግልጋሎት ኹነት፡",
    name9: "ናይ ግልጋሎት ቕልጥፍና፡",
    name10: "ናይ ግልጋሎት ፅፈት፡",
    name11: "ናይ ዓሚል ገምጋም",
    name12:"ናብ",
    name13:"ተዓፅዩ",
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ኽፈት",
    name1: "በይዘኦም እቲ ናይ ምሓዝ ሓበሬታ ስክሪንሹት የልዕሉ ከምኡዉን ናይ ቐዳምነት ግልጋሎት ንምርካብ ከም ቅብሊት የቐምጥዎ",
    name2: "ብዕዉት ኣትዩ",
    name3: "1. ዳታ ኣፅሪ",
    name4: "በይዘኦም ኣብ ስልኮም ዘሎ ጠቓሚ ናይ ዉልቀ ዳታ ኣቐዲሞም መሐለዉታ ይግበሩ",
    name5: "2. እቲ ናይ ሓይሊ ምብራህ መሕለፊ ቃል ንከይሰርሕ ይግበሩ",
    name6: "ቕድሚ ናይ ናይ ግልጋሎት መኽዘን ምኻዶም፣ በይዘኦም፡",
    name7: "ናይ ግልጋሎት መኽዘን፡",
    name8: "ቦታ ዝተትሓዘሉ ግዜ፡",
    name9: "ዝተሰሓሓተ ገለፃ",
    name10: "ናይ መሳርሒ ሞዴል፡",
    name11: "ናይ ትእዛዝ ቑፅሪ፡",
    name12: "ናይ ትእዛዝ ሓበሬታ",
  },
  title: {
    
    name1: "ዝስዕቡ ሃገራት ይድገፉ፡",
    name2: "ሞዴል ምረፅ",
    name3: "ቦታ ምሓዝ",
    name4: "ናይ ግልጋሎት መኽዘን ዝርዝራት",
    name5: "ናይ ግልጋሎት መኽዘን ምረፅ",
  },
  error: {
    
    name1: "ዳታ የለን፡፡ በይዘኦም ነቲ ናይ ፅገና ሓበሬታ የረጋግፁ",
    name2: "ተወሳኺ ሓገዘዝ ደልዩ ድዮም? በይዘኦም ይርከቡና",
    name3: "ይቕረታ! ኣብቲ ናይ ሕጂ ክልል ናይ  Carlcare ምእኸል የለን",
    name4: "በይዘኦም መጀመርታ ናይ ግልጋሎት ማእኸል ይምረፁ",
    name5: "ፈሺሉ",
    name6: "በይዘኦም መጀመርታ ናይ መሳርሒ ሞዴል ይምረፁ",
    name7: "ዝርዝራት",
    name8: "በይዘኦም ድልየቶም ብዝርዝ ይግለፁ",
    name9: "",
  },
  add1:{
    "name0": "ti-rET",
    "name1": "ትእዛዝኩም ተረጋጊፁ ኣሎ፡፡ ምምፃእኹም ብሃንቀውታ ንፅበ።",
    "name2": "ከተማ ምረፅ",
    "name3": "በይዘኦም ስልኪ ቑፅሪ %1$s ኣሃዛት የእትዉ፡፡",
    "name4": "ናይ ሰሙን መዓልቲ ሰዓታት",
    "name5": "ሰኑይ",
    "name6": "ሰሉስ",
    "name7": "ረቡዕ",
    "name8": "ሓሙስ",
    "name9": "ዓርቢ",
    "name10": "ቐዳም",
    "name11": "ሰንበት",
    "name12": "ሃገር ኣእቲኻ ድለ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "ኻልኦት",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ናብ ኣንፈት ምቕያር ዝብል ጠውቕ",
    name3:"ነቲ ትእዛዝ ደረጃ ንምሃብ ነቲ Carlcare ዓውደሞያ ኽፈት",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ግልጋሎት ምረፅ",
    name7:"ነፃ ምፅራይ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ትኽክል ዘይኮነ ሓበሬታ",
    "cancelReason1": "ብሰዓቱ ኣይበፅሐን",
    "cancelReason2": "ዝተደገመ ትእዛዝ/ናተይ ትእዛዝ ኣይኮነን",
    "cancelReason3": "ፍሽለት ኣይተደገመን",
    "cancelReason4": "ንፈተነ ጥራይ/ሕተት/ኽስተት/…",
    "cancelReason5": "ዝለዓለ ዋጋ",
    "cancelReason6": "ናይ ኣቕሓ ሕፅረት",
    "cancelReason7": "ምንም ዝተፈለየ ግልጋሎት የለን",
    "cancelReason8": "እቲ መኽዘን ኣዝዩ ርሑቕ",
    "cancelReason9": "እቲ መኽዘን ተዓፅዩ",
    "cancelReason10": "ሕማቕ ግልጋሎት ኣመለኻኽታ",
    "cancelReason11": "ንኻልኦት ብራንዳትምትካእ/ኣዐሪ",
    "cancelReason12": "ነቲ መኽዘን ምርካብ ኣይተኽኣለን",
    "cancelReason13": "ኻሊእ",
    "cancelOrder": "ትእዛዝ ሰርዝ",
    "reason_dialog_title": "በይዘኦም ናይ ዝተሰረዘሉ ምኽንያት ይንገሩና",
    "Cancel": "ይሰርዙ",
    "OK": "ሕራይ",
    "name1": "ናይ መረጋገፂ ኮድ የእትዉ",
    "name2": "ተቐባልነት ዘይብሉ ናይ መረጋገፂ ኮድ",
    "repair_reservation_detail_canceled": "እዚ ትእዛዝ ተሰሪዙ!",
    "purchase_cancel_dialog_content": "ነቲ ትእዛዝ ክትስርዞ ተረጋገፅ ዲኻ?",
    "yes": "እወ",
    "no": "ኣይኮነን"
},
onSiteService:{
  "name1": "ኣብ ውሽጢ ድኳን ጽገና",
  "name2": "ኣብ ቦታ ኣገልግሎት",
  "name3": "ነቲ ኣብቲ ስፍራ ዘሎ ኣገልግሎት ንምጥቃም ስፍራ ክትውልዑዎ ኣለኩም። በጃኹም ወሊዕኩም ደጊምኩም ፈትኑ።",
  "name4": "እባኮት ቦታዎን ይምረጡ:",
  "name5": "የአካባቢ ትእዛዞች",
  "name6": "ናይ ሕጂ ስፍራ:",
  "name7": "ኣድራሻ :",
  "name8": "ሽም",
  "name9": "ቴሌፎን፡"
}
};
